import { LinkedMonitoredArea } from '../dtos/LinkedMonitoredArea.dto'

export class AlertSettings {
	constructor(
		readonly description: string,
		readonly monitoredAreas: LinkedMonitoredArea[],
		readonly buffer: number,
		readonly minDetectionConfidence: number,
		readonly code?: number,
		readonly id?: string,
	) {}

	get areas() {
		return this.monitoredAreas.map((area) => area.name.normalize('NFD')).toString()
	}
}
